// ISO 639-1 codes: the back-end stores and compares language codes in lower case
// (see Translations.primaryLanguage in the NDTRC model).
export enum Lang {
  EN = 'en',
  NL = 'nl',
  DE = 'de',
  FR = 'fr',
}

export interface IntFileItem {
  copyright: string | null;
  filename: string;
  filetype: string;
  hlink: string;
  main: string | null;
  mediatype: 'photo' | 'video' | 'attachment';
  targetLanguage: string | null;
  title: { label: string } | null;
  trcid: string | null;
}
